import { ChattyClientDetailOfferParams } from 'types/chatty/offerParams';

export interface Check24Wireframe {
    loader: {
        addChatbotElement: (config: unknown, element: Element) => void;
        addChatbotButton: (config: unknown, isTrigger?: boolean) => void;
        defaultConfigs: {
            chatty: {
                chatbot: ChattyConfig;
            };
        };
        openChatbot(
            config?: ChatBotWireframeConfig,
            callback?: (config: ChatBotWireframeConfig) => void
        ): void;
        closeTrigger: () => void;
        chatty?: {
            usePreloading: boolean;
            currentConfig: string;
            preloaded?: boolean;
            close: () => void;
            getChattyAssetConfig: (
                config: unknown,
                callback?: (name: string, assetsConfig: unknown) => void
            ) => void;
            init: (
                chattyConfig: ChatBotWireframeConfig,
                isOpen: boolean,
                callback?: (config: ChatBotWireframeConfig) => void
            ) => void;
            open: () => void;
            checkActiveChatty: () => boolean;
            listenerInitilized: boolean;
        };
        useChatbotApp: boolean;
        storedConfigs?: {
            [key: string]: {
                chatbot: Partial<ChatBotWireframeConfig>;
            };
        };
        hideElements: () => void;
    };
}

export interface ChattyConfig {
    client: {
        controlServerAddress?: string;
        chatFlowRelease?: string;
        chatFlowEntry?: string;
        chatFlowName?: string;
        presentationType?: string;
        clientDetails?: {
            connectionInfoDetails?: ConnectionInfoDetails;
        };
        customConsole?: null | 'console';
    };
    env?: string;
    active?: boolean;
    deviceoutput?: string;
}

export interface ConnectionInfoDetails {
    serviceCode: string;
    pageScope: number;
    transactionId: string;
    plugin: string;
    travelExpertIdHash?: string;
    travelExpertRegion?: string;
    customer_input?: string;
    offer?: ChattyClientDetailOfferParams;
}

export enum BridgeEvent {
    Event = 'event',
    Response = 'response',
}

export interface BridgeInfoDetails {
    product_key: string;
    type: BridgeEvent;
    context?: ConnectionInfoDetails;
}

export interface BridgeResponse extends BridgeInfoDetails {
    correlation_id: string;
    data: BridgeData;
    action?: BridgeResponseEvents;
}

export interface BridgeResponseContext {
    context: BridgeResponse;
}
export interface BridgeData {
    [x: string]:
        | Record<string, unknown>
        | string
        | number
        | ChattyClientDetailOfferParams;
}
export enum BridgeResponseEvents {
    ApplyVoucher = 'apply_voucher',
    GetContext = 'get_context',
}

export interface ChatBotWireframeConfig {
    chatbot?: ChattyConfig;
    chattyVersion?: string;
    deviceoutput?: string;
    env?: string;
    name?: string;
    onDemand?: boolean;
    type?: string;
    element?: {
        openChatEvent?: string;
    };
}
